<script lang="ts" setup>
const { $directus, $readSingleton } = useNuxtApp()
const { dt } = useDirectusTranslation()
const signatureStore = useSignatureStore()

const { data } = await useAsyncData('terms_and_conditions', async () => {
  return await $directus.request($readSingleton('terms_and_conditions', {
    fields: [{
      translations: ['*'],
    }],
  })) as {
    translations: DirectusTranslation<{ content: string }>
  }
})

signatureStore.setIsSignaturePage(false)
</script>

<template>
  <main class="mb-8rem mt-20rem">
    <Container>
      <div class="mx-auto text-1.8rem prose prose-invert block-light:prose-neutral" v-html="dt(data?.translations)?.content" />
    </Container>
  </main>
</template>
